import { create } from "zustand";

interface BuyersHubStore {
  supplierIds: string[];
  setSupplierIds: (ids: string[]) => void;
}

export const useBuyersHubStore = create<BuyersHubStore>((set) => ({
  supplierIds: [],
  setSupplierIds: (ids) => set({ supplierIds: ids }),
}));
